import { useMemo } from 'react'

import { useWindowSize } from './use-window-size'

const BREAKPOINTS = {
  mobile: 0,
  smTablet: 480,
  tablet: 768,
  desktop: 1280,
}

/**
 * For tailwind, we use the following breakpoints:
 * - mobile: 0px
 * - smTablet(xs): 481px
 * - tablet(md): 769px
 * - desktop(xl): 1280px
 *
 * For the app, we use the following breakpoints:
 */

export type BreakpointType = keyof typeof BREAKPOINTS

// interface BpSwitchProps<T1, T2, T3, T4> {
//   // desktop (xl)
//   xl?: T1
//   // tablet (md)
//   md?: T2
//   // smTablet (xs)
//   xs?: T3
//   // default (mobile)
//   default?: T4
// }

export default function useBreakpoint() {
  const { width } = useWindowSize()

  const breakpoint: BreakpointType = useMemo(() => {
    if (width < BREAKPOINTS.smTablet) return 'mobile'
    if (width < BREAKPOINTS.tablet) return 'smTablet'
    if (width < BREAKPOINTS.desktop) return 'tablet'
    return 'desktop'
  }, [width])

  // const bpSwitch = useCallback(
  //   <T1, T2, T3, T4>({ xl, md, xs, default: mobile }: BpSwitchProps<T1, T2, T3, T4>) => {
  //     if (width >= BREAKPOINTS.desktop && xl) return xl
  //     if (width >= BREAKPOINTS.tablet && md) return md
  //     if (width >= BREAKPOINTS.smTablet && xs) return xs
  //     return mobile
  //   },
  //   [width],
  // )

  const isMobile = breakpoint === 'mobile'
  const isSmTablet = breakpoint === 'smTablet'
  const isTablet = breakpoint === 'tablet'
  const isDesktop = breakpoint === 'desktop'

  const isSmTabletOrSmaller = isMobile || isSmTablet
  const isTabletOrSmaller = isSmTabletOrSmaller || isTablet

  return {
    breakpoint,
    isMobile,
    isSmTablet,
    isTablet,
    isDesktop,
    isSmTabletOrSmaller,
    isTabletOrSmaller,
    // bpSwitch,
  }
}
